'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Spinner = require('./Spinner.styled');

var _Spinner2 = _interopRequireDefault(_Spinner);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var Wrapper = function Wrapper(_ref) {
  var _ref$className = _ref.className,
      className = _ref$className === undefined ? '' : _ref$className,
      isShowing = _ref.isShowing,
      small = _ref.small,
      light = _ref.light,
      rest = _objectWithoutProperties(_ref, ['className', 'isShowing', 'small', 'light']);

  return _react2.default.createElement(_Spinner2.default, _extends({
    className: className + ' life-spinner__container life-spinner__loader',
    isShowing: isShowing,
    small: small,
    light: light
  }, rest));
};

Wrapper.propTypes = process.env.NODE_ENV !== "production" ? {
  className: _propTypes2.default.string,
  isShowing: _propTypes2.default.bool,
  small: _propTypes2.default.bool,
  light: _propTypes2.default.bool
} : {};

exports.default = Wrapper;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/li-components/lib/Spinner/index.js
// module id = 332
// module chunks = 14